import { useEffect, useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import DropDownSelection from './DropDownSelection';
import LoadingPage from '../../components/LoadingPage';
import DeleteConfirmationPopup from './DeleteConfirmationPopup';

export default function VerticalDragableList(props) {
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [list, setList] = useState(props.lists || []);
    const { fontSize } = useSetting();
    const [isLoading, setIsLoading] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    useEffect(() => {
        setList(props.lists || []);
    }, [props.lists]);

    const updateList = (newList,save=false) => {
        setList(newList);
        if (save) {
            saveList(newList);
        }
    };
    const saveList = (newList=null) => {
        if (newList === null) {
            newList = list;
        }
        if (props.onUpdate) {
            for (let i = 0; i < newList.length; i++) {
                newList[i].isEditing = false;
            }
            props.onUpdate(newList);
        }
    };

    const handleDrop = (dropIndex) => {
        if (draggedIndex === null || draggedIndex === dropIndex) {
            setDraggedIndex(null);
            return;
        }

        const newList = [...list];
        const [draggedItem] = newList.splice(draggedIndex, 1);
        newList.splice(dropIndex, 0, draggedItem);
        updateList(newList,true);
        setDraggedIndex(null);
    };
    const handleToggleEdit = (index) => {
        const newList = [...list];
        newList[index].isEditing = !newList[index].isEditing;
        updateList(newList);
    };
    const handleDelete = (index) => {
        const newList = [...list];
        newList.splice(index, 1);
        updateList(newList,true);
    };
    const handleCancel = (index) => {
        const newList = [...list];
        newList[index].isEditing = false;
        updateList(newList);
    };
    const handleToggleSelect = (index) => {
        const newList = [...list];
        newList[index].selected = !newList[index].selected;
        updateList(newList,true);
    };

    const suggestionList =props.suggestionList || [];
    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };
    const handlSelectAbilityPoint = (item,index) => (newValue) => {
        if (newValue==='取消'){
             const newList = [...list];
            newList[index].ability_point = null;
            updateList(newList);
            return;
        }
        //select a question from suggestion list
        const newList = [...list];

        const availableSuggestions = suggestionList.filter(q=>q.category==='能力點題' && q.ability_point === newValue && q.type === item.type);
        shuffleArray(availableSuggestions);
        let selectedQuestion = null;
        for(let q of availableSuggestions) {
            //check if q.id already in list
            if (newList.some(item => item.id === q.id)) {
                //ignore
            }else{
                selectedQuestion = q;
                break;
            }
        }
        if(!selectedQuestion && availableSuggestions.length > 0) {
            selectedQuestion = availableSuggestions[Math.floor(Math.random() * availableSuggestions.length)];
        }

        newList[index]=JSON.parse(JSON.stringify({
            ...selectedQuestion,
            isEditing: true,
        }));
        updateList(newList);
    };
    const handleAIButton=(item,index)=>()=>{
        setIsLoading(true);
        const newList = [...list];
        const availableSuggestions =
            item.ability_point==='取消' || !item.ability_point
         ?suggestionList.filter(q=>q.category==='一般閱讀題' && q.type === item.type)
         :suggestionList.filter(q=>q.category==='能力點題' && q.ability_point === item.ability_point && q.type === item.type);
        shuffleArray(availableSuggestions);
        let selectedQuestion = null;
        for(let q of availableSuggestions) {
            //check if q.id already in list
            if (newList.some(item => item.id === q.id)) {
                //ignore
            }else{
                selectedQuestion = q;
                break;
            }
        }
        if(!selectedQuestion && availableSuggestions.length > 0) {
            selectedQuestion = availableSuggestions[Math.floor(Math.random() * availableSuggestions.length)];
        }
        newList[index]=JSON.parse(JSON.stringify({
            ...selectedQuestion,
            isEditing: true,
        }));
        updateList(newList);
        setTimeout(() => {
            setIsLoading(false);
        }, 500);
    }

    return (
        <div className='flex flex-col w-full h-full overflow-auto gap-[4px] font-bold' style={{ fontSize }}>
            {list.map((item, index) => (
                item?.isEditing ?
                    <div key={index} className='flex flex-col w-full bg-[#E1E1E1] rounded-[8px]'>
                        <div
                            className='flex flex-row items-start justify-between p-[8px]' style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                            onDragOver={(event) => event.preventDefault()}
                            onDrop={() => handleDrop(index)}
                        >
                            {/*drag handle*/}
                            <div
                                className='cursor-move'
                                draggable
                                onDragStart={() => setDraggedIndex(index)}
                                onDragEnd={() => setDraggedIndex(null)}
                            >
                                ☰
                            </div>
                            <div className='flex flex-col w-full'>
                                <div className='flex flex-row flex-1 items-start gap-[4px] ml-[8px]'>
                                    <div className='flex flex-col items-cente gap-[4px]'>
                                        <DropDownSelection value={item?.type || ''} options={['選擇題', '短答題']} onUpdate={(newValue) => { const newList = [...list]; newList[index].type = newValue; updateList(newList); }} />
                                        <DropDownSelection value={item?.ability_point || '能力點'} options={[
                                            '取消',
                                            '1.1 獲取並提取文本內信息',
                                            '1.2 跨來源搜索、導航與篩選',
                                            '2.1 建構文本字面意義',
                                            '2.2 生成推斷',
                                            '2.3 整合文本內信息',
                                            '2.4 整合跨文本信息',
                                            '3.1 評估質量與真實性',
                                            '3.2 反思內容與形式',
                                            '3.3 發現並處理衝突',
                                            '4.1 將理解遷移至新情境',
                                            '4.2 創造並傳達新意義',             
                                        ]} onUpdate={handlSelectAbilityPoint(item,index)} />
                                    </div>
                                    <div className='flex flex-col text-black flex-1 ml-[4px] bg-[#ffffffa0] p-[4px] rounded-[8px]' style={{ border: '1px solid white' }}>
                                        <textarea className='flex-1 px-[4px] rounded-[4px] bg-[transparent] min-h-[100px]' value={item?.question} onChange={(e) => { const newList = [...list]; newList[index].question = e.target.value; updateList(newList); }} />
                                        <div className='w-full flex flex-row justify-end'>
                                            <button onClick={handleAIButton(item,index)} className='flex flex-row items-center px-[12px] gap-[4px] text-white rounded-[99px]' style={{ background: 'linear-gradient(to right, #178E95, #07162F)' }}>
                                                <img src='/secondary/ai.png' className='w-[16px]' alt='AI生成' />
                                                AI生成
                                            </button>
                                        </div>
                                    </div>
                                    <button onClick={() => setDeleteIndex(index)}>
                                        <img src='/secondary/delete.png' className='w-[16px]' alt='edit' />
                                    </button>
                                </div>
                                {item?.type === '選擇題' && (item?.options || []).map((option, optionIndex) => (
                                    <div key={optionIndex} className='flex flex-row items-center gap-[4px] mt-[6px] ml-[10px]'>
                                        <div className='flex flex-row items-center gap-[12px] w-[120px] justify-center'>
                                            [選擇 {optionIndex + 1}]
                                            <input type='checkbox' style={{ width: '16px', height: '16px' }} checked={item?.correctAnswer === option.option} onChange={(e) => {
                                                const newList = [...list];
                                                newList[index].correctAnswer = e.target.checked ? option.option : '';
                                                updateList(newList);
                                            }} />
                                        </div>
                                        <input type='text' value={option?.option} style={{border:'1px solid white'}}onChange={(e) => {
                                            const newList = [...list];
                                            newList[index].options[optionIndex].option = e.target.value;
                                            updateList(newList);
                                        }} className='flex-1 py-[4px] rounded-[8px] bg-[#ffffff90] text-black px-[12px]' />
                                        <button onClick={() => {
                                            const newList = [...list];
                                            newList[index].options.splice(optionIndex, 1);
                                            updateList(newList);
                                        }}>
                                            <img src='/secondary/delete2.png' className='w-[16px]' alt='delete' />
                                        </button>
                                    </div>
                                ))}
                                <div className='flex flex-row items-center gap-[4px] justify-center mt-[4px]'>
                                    {item?.type === '選擇題' && (
                                        <button onClick={() => {
                                            const newList = [...list];
                                            newList[index].options = newList[index].options || [];
                                            newList[index].options.push({ option: '', isSelected: false });
                                            updateList(newList);
                                        }}>
                                            <img src='/secondary/add.png' className='w-[32px]' alt='add' />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-row w-full bg-[#ffffff80] p-[16px] rounded-[8px]'>
                            <div className='text-[#a0a0a0] flex flex-row items-center gap-[4px]'>
                                <img src='/secondary/edit2.png' className='w-[16px]' alt='edit' />
                                編輯模式
                            </div>
                            <div className='flex flex-row items-center gap-[14px] flex-1 justify-center'>
                                <button className='bg-[#A9A9A9] text-white px-[36px] py-[4px] rounded-full' onClick={() => handleCancel(index)}>
                                    取消
                                </button>
                                <button className='bg-[#178E95] text-white px-[36px] py-[4px] rounded-full' onClick={() => {
                                    saveList();
                                }}>
                                    儲存
                                </button>
                            </div>
                        </div>
                    </div>

                    : <div
                        key={index}
                        className='flex flex-row items-start justify-between p-[8px]' style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                        onDragOver={(event) => event.preventDefault()}
                        onDrop={() => handleDrop(index)}
                    >
                        {/*drag handle*/}
                        <div
                            className='cursor-move'
                            draggable
                            onDragStart={() => setDraggedIndex(index)}
                            onDragEnd={() => setDraggedIndex(null)}
                        >
                            ☰
                        </div>
                        <div className='flex flex-row flex-1 items-start gap-[4px] ml-[8px]'>
                            <div className='flex flex-row items-center gap-[4px]'>
                                <input type='checkbox' checked={item?.selected || false} onChange={() => handleToggleSelect(index)} />
                                <div>[{(item?.type!=='選擇題')&&(item?.type!=='短答題')?'建議題目':item?.type}]</div>
                            </div>
                            <div className='text-black flex-1'><div dangerouslySetInnerHTML={{__html:item?.question}}/></div>
                            {item?.isNotEditable?null:<button onClick={() => handleToggleEdit(index)}>
                                <img src='/secondary/edit.png' className='w-[22px]' alt='edit' />
                            </button>}
                        </div>
                    </div>
            ))}
            {deleteIndex !== null && (
                <DeleteConfirmationPopup
                    onCancel={() => setDeleteIndex(null)}
                    onDelete={() => {
                        handleDelete(deleteIndex);
                        setDeleteIndex(null);
                    }}
                />
            )}
            {isLoading && <LoadingPage />}
        </div>
    );
}


